export default {"src":"https://search.prod.wiggot.com/_next/static/media/for-sale-to-live.febae12f.svg","height":22,"width":36,"blurWidth":0,"blurHeight":0};